import { prettyFloatMoney, round } from '@/helpers/utils';

const MONEY_FIELDS = [
  'scenario_amount',
  'delta_future_value',
  'bonus_group_bonus',
  'bonus_group_bonus_per_step',
  'bonus_group_step',
  'opportunity_cost',
  'ncf_bonus',
];

const SHARE_FIELDS = ['group_a_share', 'group_b_share'];

export function buildVariables(rawVariables, t) {
  if (!rawVariables) return {};
  const { term_months: termMonths } = rawVariables;
  const out = { ...rawVariables };
  MONEY_FIELDS.forEach(field => {
    out[`${field}_formatted`] = prettyFloatMoney(rawVariables[field]);
  });
  SHARE_FIELDS.forEach(field => {
    const value = rawVariables[field];
    out[`${field}_formatted`] =
      typeof value === 'number' ? `${round(value, { decimalPlaces: 1 })}%` : '';
  });
  if (typeof termMonths === 'number') {
    out.term_months_plural = t('containers:decision_widget.term_months', { count: termMonths });
  }
  return out;
}